var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container has-text-centered"},[_c('div',{staticClass:"column is-half is-offset-one-quarter"},[_c('p',{staticClass:"back"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v(" Ir a la inscripción ")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }